import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';

const init = () => {
  const player = document.getElementById('js-wildverband-logo');
  if (!player) {
    console.warn('Player element is missing');
    return;
  }

  player.addEventListener('load', () => {
    // params to show animation faster if we have short page
    const OPTIMAL_HEIGHT = 8600;
    const REAL_HEIGHT = document.getElementById('app').clientHeight;
    // For a short page, the optimal value is 0.65, for a medium one – 0.8
    const tmpOffset = 0.8 - (REAL_HEIGHT / OPTIMAL_HEIGHT);
    const OFFSET = tmpOffset > 0.45 ? tmpOffset - 0.15 : (tmpOffset < 0.05 ? 0 : tmpOffset);
    create({
      mode: 'scroll',
      speed: 20,
      container: 'html',
      player: '#js-wildverband-logo',
      actions: [
        {
          visibility: [OFFSET, 1 - OFFSET],
          type: 'seek',
          // 16 sec, 60fps
          frames: [0, 16 * 60],
        },
      ],
    });
  });
  player.addEventListener('ready', () => {
    const shadowHost = document.getElementById('js-wildverband-logo');
    const shadowRoot = shadowHost.shadowRoot;
    const svg = shadowRoot.querySelector('svg');
    const paths = svg.querySelectorAll('path');
    paths.forEach((path) => {
      if (path.getAttribute('fill') === 'rgb(29,29,27)') {
        path.setAttribute('fill', 'currentColor');
      }
    });
  });
};

export default {
  init,
};
